import styled from "styled-components"

export const AgreementHeaderText = styled.h1`
  color: var(--font-heading);
  font-size: var(--text-font-size-lg);
`
